import { render, staticRenderFns } from "./CombinationText.vue?vue&type=template&id=d21c6490&scoped=true"
import script from "./CombinationText.vue?vue&type=script&lang=js"
export * from "./CombinationText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21c6490",
  null
  
)

export default component.exports